import {loadElementLazyImage} from './helpers/lazy-load'
import LocomotiveScroll from 'locomotive-scroll'
import { breakpointUp } from './helpers/breakpoints'
import { setUrlHash } from './sections/navigation'

let locoScrollPopup = null

export function initializePopups(locoScroll){


  $('.js-open-popup').click(function(){
    let popupId = $(this).data('popup')
    openPopup(popupId, locoScroll)
  })


  $('.js-close-popup').click(function(){
    let popup = $(this).closest('.js-popup')
    closePopup(popup, locoScroll)
  })


  $('.popup').click(function(e){
    let target = $(e.target)
    if (target.hasClass('popup-flex')) {
      let popup = target.closest('.js-popup')
      if (!popup.hasClass('js-cookies-popup'))
        closePopup(target.closest('.js-popup'), locoScroll)
    }
  })

  $(document).keyup(function(e) {
    if (e.key === "Escape") { // escape key maps to keycode `27`
      closePopup($('.js-popup'), locoScroll)
    }
  });



}


export function closePopup(popup, locoScroll){
  popup.fadeOut()
  $('html').removeClass('modal-open')

  popup.find('video').each(function(){
    this.pause()
  })

  if (locoScrollPopup){
    locoScrollPopup.destroy()
    $('html').addClass('has-scroll-smooth')
    locoScroll.start()
  }

  setUrlHash($('.js-go-to.js-active').data('go-to'))
}


export function openPopup(popupId, locoScroll){
  let popup = $('.js-popup[data-popup="'+popupId+'"]')
  if (popup.length) {
    loadElementLazyImage(popup.find('.lazy'))
    popup.fadeIn()
    $('html').addClass('modal-open')


    if (popup.hasClass('js-locomotive-popup')) {
      if (breakpointUp('lg')) {
        locoScroll.stop()
        locoScrollPopup = new LocomotiveScroll({
          el: popup[0],
          smooth: true,
          reloadOnContextChange: true
        })
      }

    }

    if (popupId !== 'cookies') {
      setUrlHash('popup-'+popupId)
    }
  }
}




